import * as React from 'react';
import { createViewConfig, view } from '@sail/engine';
import { useCollectionState } from '@sail/react-aria';
import { Checkbox } from './Checkbox';
import useFauxTreeState from '../hooks/useFauxTreeState';
import { css } from '../css';
const defaultSelectedText = (itemsCount, totalCount)=>{
    if (itemsCount > 0) {
        const allSelected = itemsCount === totalCount;
        if (allSelected) {
            return `Deselect all`;
        }
        return `${itemsCount} selected`;
    } else {
        return `Select all`;
    }
};
export const FauxTreeSelectAllItemConfig = createViewConfig({
    name: 'FauxTreeSelectAllItem',
    props: {},
    defaults: {
        selectedText: defaultSelectedText
    }
});
export const FauxTreeSelectAllItem = FauxTreeSelectAllItemConfig.createView((allProps)=>{
    const { subviews, selectedText, selectAllRef, ...props } = allProps;
    const state = useCollectionState();
    const { selectAllItem, selectGroupItems } = useFauxTreeState();
    const { selectedCount, totalCount, selectedHiddenCount, checkableKeys, uncheckableKeys, isDisabled } = selectAllItem;
    const areAllSelected = totalCount === selectedCount;
    const areAllEnabledSelected = checkableKeys.length - selectedHiddenCount === selectedCount;
    // TODO: Sail Checkbox has a visual bug in Chrome when the values of indeterminate and checked are modified in the same render.
    // This is a workaround to avoid it, but this bug must be fixed directly in Checkbox
    const [indeterminate, setIndeterminate] = React.useState(selectedCount !== 0 && !areAllSelected);
    React.useEffect(()=>{
        setIndeterminate(selectedCount !== 0 && !areAllSelected);
    }, [
        selectedCount,
        areAllSelected
    ]);
    return /*#__PURE__*/ React.createElement(view.div, {
        ...props,
        css: [
            selectGroupItems.size > 0 ? css({
                marginBottom: "xsmall"
            }) : css({
                marginBottom: "space.0"
            }),
            !isDisabled ? css({
                cursor: 'pointer'
            }) : css({
                cursor: 'default'
            })
        ]
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        tabIndex: -1,
        ...selectAllRef ? {
            ref: selectAllRef
        } : {},
        indeterminate: indeterminate,
        label: selectedText ? selectedText(selectedCount, totalCount) : defaultSelectedText(selectedCount, totalCount),
        checked: areAllSelected,
        disabled: isDisabled,
        subviews: {
            label: {
                css: [
                    css({
                        marginLeft: '-2px',
                        font: 'label.small.emphasized',
                        color: 'subdued'
                    }),
                    !isDisabled ? css({
                        cursor: 'pointer'
                    }) : css({
                        cursor: 'default'
                    })
                ],
                ...subviews === null || subviews === void 0 ? void 0 : subviews.label
            },
            input: {
                css: {
                    ':focus': {
                        focusRing: 'none'
                    }
                },
                ...subviews === null || subviews === void 0 ? void 0 : subviews.input
            },
            ...subviews
        },
        onChange: ()=>{
            if (areAllEnabledSelected) {
                state.selectionManager.setSelectedKeys(uncheckableKeys);
            } else {
                state.selectionManager.setSelectedKeys(checkableKeys);
            }
        }
    }));
}, {
    css: {
        stack: 'x',
        font: 'label.small.emphasized',
        color: 'subdued',
        gap: 'space.75',
        borderRadius: 'xsmall',
        paddingY: 'space.75',
        paddingX: 'space.125',
        alignX: 'start',
        alignY: 'center',
        minHeight: 'xlarge'
    }
});

//# sourceMappingURL=FauxTreeSelectAllItem.js.map